
import './App.scss';
import "../src/styles/global.scss"
// import Login from "./components/login/Login"
import { BrowserRouter , Route, Routes,Navigate } from "react-router-dom";
// import { HashRouter } from 'react-router-dom';
// import { BrowserRouter } from 'react-router-dom';
import React, { Suspense, useEffect, useLayoutEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
// import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import getAxios from './components/axios/Axios';
import {request} from './components/request/request';
import { Flex } from 'antd/es';
import { Spin } from 'antd/es';
import Loader from './components/loader/Loader';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import { Flex, Spin } from 'antd';

const Login = React.lazy(() => import('./views/pages/login/Login'))
const ForgetPass = React.lazy(() => import('./views/pages/login/ForgetPassword'))
const Home = React.lazy(() => import('./views/pages/home/Home'))
const loading = (
  <Flex fullscreen justify="center" style={{ alignItems: "center", height: "100vh" }}>
    <Spin size="large" />
  </Flex>
)


function App() {


  const [loginStatus, setLoginStatus] = useState(false)
  const { loader, login } = useSelector((state) => state)
  const dispatch = useDispatch()
  const loginCheck = async () => {

    console.log("3333", login);
    const res = await getAxios(request.whoami)

    console.log("444", res?.data?.apiresponse?.code);
    if (res?.data?.apiresponse?.code==='LOGGEDIN') {
      console.log("1111");
      localStorage.setItem('login',true)
      dispatch({ type: "login", login: true })
    } else {
      dispatch({ type: "login", login: false })
      localStorage.setItem('login',false)
      // window.location.href = "/#/login"
    }
  }


  useEffect(() => {
    dispatch({ type: "loader", loader: true })
    setTimeout(() => {
      dispatch({ type: "loader", loader: false })
    }, 1000)
  }, [])


  console.log("88", window.location.href);
  useLayoutEffect(() => {
    loginCheck()
  }, [])

  useEffect(()=>{
    setLoginStatus(JSON.parse(localStorage.getItem('login')))
  },[localStorage.getItem('login')])
  console.log(login,'log in');
  if (loader) {
    return (
      <Loader />
    )
  }

  return (

    <BrowserRouter>

      <div className='' style={{ minHeight: '100vh' }}>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable={false}
          pauseOnHover
          theme="light"
        />
        <Suspense fallback={loading}>
          <Routes fallback={loading}>
            {login || JSON.parse(localStorage.getItem('login')) ? (
              <>
                {/* <Route fallback={loading} path="/login" name="Login Page" element={<Login />}  path="/*" element={<Navigate to="/dashboard" />}/>
                <Route fallback={loading} path="/forget-password" name="Forget Password Page" element={<ForgetPass />} /> */}
                {/* <Route fallback={loading} path="/forget-password" name="Forget Password Page" element={<ForgetPass />} /> */}
                <Route fallback={loading} path="/*" name="Dashboard Page" element={<Navigate to="/dashboard" />} />
                {/* <Route fallback={loading} path="/login" element={<Login />} /> */}
                <Route exact path="/dashboard" element={<Home />} />
              </>
            )
            :
              <>
                <Route fallback={loading} path="/*" name="Login Page" element={<Navigate to="/login" />} />
                <Route fallback={loading} path="/login" element={<Login />} />
                <Route fallback={loading} path="/forgot-password" name="Forget Password Page" element={<ForgetPass />} />
              </>
            }
          </Routes>
        </Suspense>
      </div>
    </BrowserRouter >
  );
}


export default App;
